import css from "styled-jsx/css";
import colors from "styles/colors.js";

export const componentStyles = css.global`
  .footer-bottom-bar-security-link-component {
    display: flex;
    margin-right: -20px;

    .security-logos-wrapper {
      margin-left: 24px;
    }
  }
`;
